<template>
  <div class="PuntosNuevo">
    <h1>Punto nuevo</h1>
    <md-layout md-flex="100" md-align="center">
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="40" md-flex-large="30" md-flex-xlarge="30">
        <div class="md-title">Información del cliente</div><br>
        <p>
          <strong>Cuenta:</strong> {{punto.cuenta}}<br>
          <strong>Razón social:</strong> {{punto.nombre}}<br>
          <strong>R.F.C.:</strong> {{punto.rfc}}<br>
          <strong>Email_</strong> {{punto.email}}<br>
          <strong>Teléfono:</strong> <a :href="`tel:${punto.telefono}`">{{punto.telefono}}</a><br>
          <strong>Domicilio:</strong>
          {{punto.calle+' #'+punto.numero}}.<br> Colonia {{punto.colonia}}. CP {{punto.codigo_postal}}<br>
          {{punto.municipio}}, {{punto.estado}}<br>
          <strong>Notas:</strong> {{punto.notas}}<br>
        </p>
      </md-layout>
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="60" md-flex-large="70" md-flex-xlarge="50">
        <md-card class="w-100">
          <md-card-header>
            <div class="md-title">Información del punto</div>
            <div class="md-subhead">Los campos marcados con * son obligatorios</div>
          </md-card-header>
          <md-card-content>
            <md-layout md-flex="100" md-gutter="24">
              <md-layout md-flex="100">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_nombre }">
                  <label>Nombre del punto</label>
                  <md-input v-model="punto.nombre_pun" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="50" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_guardias }">
                  <label>Guardias requeridos</label>
                  <md-input v-model="punto.guardias_pun" type="number" min="1" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="50" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_presupuesto }">
                  <label>Presupuesto</label>
                  <md-input v-model="punto.presupuesto_pun" type="number" step=".01" min="0" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="70" md-flex-small="70" md-flex-medium="70" md-flex-large="70" md-flex-xlarge="70">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_calle }">
                  <label>Calle</label>
                  <md-input v-model="punto.calle_pun" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="30" md-flex-small="30" md-flex-medium="30" md-flex-large="30" md-flex-xlarge="30">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_num_ext }">
                  <label># ext</label>
                  <md-input v-model="punto.num_ext_pun" required></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="70" md-flex-small="70" md-flex-medium="70" md-flex-large="70" md-flex-xlarge="70">
                <md-input-container>
                  <label>Colonia</label>
                  <md-input v-model="punto.colonia_pun"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="30" md-flex-small="30" md-flex-medium="30" md-flex-large="30" md-flex-xlarge="30">
                <md-input-container>
                  <label>C.P.</label>
                  <md-input v-model="punto.cp_pun"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="50" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
                <md-input-container>
                  <label>Municipio</label>
                  <md-input v-model="punto.municipio_pun"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="50" md-flex-small="50" md-flex-medium="50" md-flex-large="50" md-flex-xlarge="50">
                <md-input-container>
                  <label>Estado</label>
                  <md-input v-model="punto.estado_pun"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex="100">
                <md-input-container>
                  <label>Notas</label>
                  <md-textarea v-model="punto.notas_pun"></md-textarea>
                </md-input-container>
              </md-layout>
            </md-layout>
          </md-card-content>
          <md-card-actions>
            <router-link tag="md-button" to="/puntos">Cancelar</router-link>
            <md-button @click.native="actualizarPunto()" class="md-primary md-raised">Guardar cambios</md-button>
          </md-card-actions>
        </md-card>
      </md-layout>
    </md-layout>
  </div>
</template>

<script>
  import sha1 from 'js-sha1'
  import md5 from 'blueimp-md5'
  import Snackbar from 'node-snackbar'
  export default {
    name: 'PuntosNuevo',
    methods: {
      obtenerPunto(){
        this.$http.post('puntos/obtener',{
          token: this.$session.get('token'),
          id: this.$route.params.punto
        })
        .then(response => {
          if (response.status === 200 && 'punto' in response.body) {
            this.punto   = response.body.punto
          }else{
            Snackbar.show({
              text: response.body.error,
              actionText:'Cerrar',
              showAction: false,
              pos: 'top-right',
              backgroundColor:'#F44336',
              actionTextColor:'#FFF'
            });
            //this.$router.push('/puntos');
          }
        }, response => {
          Snackbar.show({
            text:'No se pudo establecer conexión con el servidor.',
            actionText:'Cerrar',
            showAction: false,
            pos: 'top-right',
            backgroundColor:'#F44336',
            actionTextColor:'#FFF'
          });
          //this.$router.push('/puntos');
        });
      },
      actualizarPunto(){
        if(this.validarInformacion()){
          this.$http.post('puntos/actualizar',{
            token: this.$session.get('token'),
            data: this.punto,
            id: this.$route.params.punto
          })
          .then(response => {
            if (response.status === 200 && 'msg' in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText:'Cerrar',
                showAction: false,
                pos: 'top-right',
              });
              this.$router.push('/puntos');
            }else{
              Snackbar.show({
                text: response.body.error,
                actionText:'Cerrar',
                showAction: false,
                pos: 'top-right',
                backgroundColor:'#F44336',
                actionTextColor:'#FFF'
              });
            }
          }, response => {
            Snackbar.show({
              text:'No se pudo establecer conexión con el servidor.',
              actionText:'Cerrar',
              showAction: false,
              pos: 'top-right',
              backgroundColor:'#F44336',
              actionTextColor:'#FFF'
            });
          });
        }
      },
      validarInformacion(){
        !this.punto.nombre_pun ? this.val.v_nombre = true : this.val.v_nombre = false;
        !this.punto.guardias_pun ? this.val.v_guardias = true : this.val.v_guardias = false;
        !this.punto.presupuesto_pun ? this.val.v_presupuesto = true : this.val.v_presupuesto = false;
        !this.punto.calle_pun ? this.val.v_calle = true : this.val.v_calle = false;
        !this.punto.num_ext_pun ? this.val.v_num_ext = true : this.val.v_num_ext = false;
        if(this.val.v_nombre || this.val.v_guardias || this.val.v_presupuesto || this.val.v_calle || this.val.v_num_ext){
          Snackbar.show({
            text:'Por favor llene todos los campos marcados con *',
            actionText:'Cerrar',
            showAction: false,
            pos: 'top-right',
            duration: 10000,
            backgroundColor:'#CC3D30',
            actionTextColor:'#FFF'
          });
          return false
        }else{
          return true
        }
      }
    },
    beforeCreate(){
      if (!this.$session.exists()) {
        this.$router.push('/login')
      }
    },
    created(){
      this.obtenerPunto()
    },
    data(){
      return {
        msg: 'Inicio',
        punto: {
          id_cli_pun: null,
          nombre_pun: null,
          guardias_pun: null,
          presupuesto_pun: null,
          calle_pun: null,
          num_ext_pun: null,
          colonia_pun: null,
          cp_pun: null,
          municipio_pun: null,
          estado_pun: null,
          notas_pun: null,
          //Información del cliente
          cuenta: null,
          nombre: null,
          rfc: null,
          email: null,
          telefono: null,
          estado: null,
          municipio: null,
          ciudad: null,
          calle: null,
          colonia: null,
          numero: null,
          codigo_postal: null,
          notas: null,
        },
        val: {
          v_nombre: null,
          v_guardias: null,
          v_presupuesto: null,
          v_calle: null,
          v_num_ext: null,
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// PuntosEditar.vue?3de4675f